import { useContext } from "react"
import { CadasBannerFornecedorContext } from "./CadasBannerFornecedorContext"

export function useCadasBannerFornecedorContext() {
    return useContext(CadasBannerFornecedorContext)
}
